'use client';

import React from 'react';
import TabletLayout from '@/components/TabletLayout';
import LucatHeader from '@/components/LucatHeader';
import LucatButton from '@/app/components/LucatButton';
import FamilyContacts from '@/app/components/FamilyContacts';
import QuickTilesGrid from '@/app/components/QuickTilesGrid';
import ContactMeBar from '@/app/components/ContactMeBar';
import HomeModeSelectionScreen from '@/app/components/HomeModeSelectionScreen';
import EssentialHomeScreen from '@/app/components/EssentialHomeScreen';
import { useHomeMode } from '@/lib/HomeModeContext';

// ── Complete Home (existing layout) ─────────────────────────────────────────
function CompleteHomeScreen() {
  return (
    <TabletLayout overflow="hidden">
      {/* Header with settings gear as proper flex sibling */}
      <LucatHeader showSettings />

      {/* Main content — two columns, fills remaining height */}
      <main style={{
        flex: 1,
        display: 'flex',
        gap: '0',
        overflow: 'hidden',
        padding: 'clamp(10px, 1.2vh, 16px) clamp(12px, 1.5vw, 20px) 0 clamp(12px, 1.5vw, 20px)',
        minHeight: 0,
      }}>
        {/* Left column — 58% */}
        <div style={{
          width: '58%',
          display: 'flex',
          flexDirection: 'column',
          gap: 'clamp(8px, 1vh, 14px)',
          paddingRight: 'clamp(10px, 1.2vw, 14px)',
          minWidth: 0,
          minHeight: 0,
          overflow: 'hidden',
        }}>
          <LucatButton />
          <FamilyContacts />
        </div>

        {/* Right column — 42% */}
        <div style={{
          width: '42%',
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          minHeight: 0,
          overflow: 'hidden',
        }}>
          <QuickTilesGrid />
        </div>
      </main>

      {/* Bottom bar */}
      <ContactMeBar />
    </TabletLayout>
  );
}

// ── Essential Home wrapper ───────────────────────────────────────────────────
function EssentialHomeWrapper() {
  return (
    <TabletLayout overflow="hidden">
      {/* Header with settings gear as proper flex sibling */}
      <LucatHeader showSettings />
      <EssentialHomeScreen />
    </TabletLayout>
  );
}

// ── Root page — routes based on homeMode ─────────────────────────────────────
export default function HomeScreen() {
  const { homeMode, loading } = useHomeMode();

  // While reading localStorage, show nothing (avoids flash)
  if (loading) {
    return (
      <div style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(160deg, #EFF6FF 0%, #FBF8F3 60%, #F0FBE8 100%)',
      }}>
        <div style={{ fontSize: '20px', color: '#5A6A7A', fontWeight: 600 }}>Chargement…</div>
      </div>
    );
  }

  // No preference yet — show selection screen
  if (homeMode === null) {
    return <HomeModeSelectionScreen />;
  }

  // Essential mode
  if (homeMode === 'essential') {
    return <EssentialHomeWrapper />;
  }

  // Complete mode (default)
  return <CompleteHomeScreen />;
}